module.exports = __webpack_public_path__ + "img/extended.6bda9887.png";